export const PERMISSIONS_STATUS = {
  PROMPT: 'prompt',
  DENIED: 'denied',
  GRANTED: 'granted',
}
